import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface BannerData {
  _id?: string;
  id?: string;
  bannerType: string; // 'error', 'warning', 'success', 'info'
  bannerText: string;
  bannerFileName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  hideBanner = false;

  constructor(private http: HttpClient) {}

  /**
   * Fetch banner data for external bannerLocation
   */
  getBannerData(): Observable<BannerData> {
    return this.http.get<BannerData>('/api/ext/banner?bannerLocation=external');
  }

  /**
   * Get file stream from banner
   */
  getFileStream(id: string): Observable<Blob> {
    return this.http.get(`/api/ext/banner/file/${id}`, { responseType: 'blob' });
  }
}
